<template>
  <b-modal
    ref="modal-confirm"
    id="modal-confirm"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="px-3 py-5 text-center">
      <img src="@/assets/icon-delete.png" alt="" width="120" height="120">
      <h4 class="text-bold mt-4">Submit Rental Equipment</h4>
      <p class="text-muted mb-5">
        Are you sure want to submit this rental equipment?
      </p>
      <div class="d-flex justify-content-around align-items-center mt-5">
      <b-button class="btn-reset px-5" variant="outline-info" @click="submit">
        Yes
      </b-button>
      <b-button class="btn-custom px-5" variant="info" @click="cancel">
        No
      </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  methods: {
    submit() {
      this.$bvModal.hide('modal-confirm')
      this.$emit('submit')
    },
    cancel() {
      this.$bvModal.hide('modal-confirm')
    }
  }
}
</script>
